class TuckyLooxCards extends HTMLElement {
  /** @type {HTMLElement | null} */
  nativeReviews = null;
  /** @type {HTMLElement | null} */
  fullWidget = null;

  connectedCallback() {
    if (this.nativeReviews) return;
    this.nativeReviews = this.querySelector('div[data-native-reviews]');
    this.fullWidget = this.querySelector('div[data-full-loox]');
    if (!this.nativeReviews || !this.fullWidget || !this.querySelector('.pdp-loox-cards__card')) return;
    this.openWidget = this.openWidget.bind(this);
    this.addEventListener('click', this.openWidget);
    this.nativeReviews.hidden = false;
    this.fullWidget.hidden = true;
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.openWidget);
    this.nativeReviews = null;
    this.fullWidget = null;
  }

  /** @param {MouseEvent} event */
  openWidget(event) {
    if (!(event.target instanceof Element) || !event.target.closest('[data-open-loox]')) return;
    if (!this.fullWidget || !this.nativeReviews) return;
    this.fullWidget.hidden = false;
    this.nativeReviews.hidden = true;
    window.dispatchEvent(new Event('resize'));
    this.fullWidget.scrollIntoView({ block: 'start' });
  }
}

if (!customElements.get('tucky-loox-cards')) {
  customElements.define('tucky-loox-cards', TuckyLooxCards);
}
